import { ServiceFieldType } from '@onlog-public/additional-services-types';

import { OptionsCache } from '../services/optionsLoader/types';
import { AServiceCache } from '../types';

/**
 * Дефолтный стейт кеша доп. услуг.
 */
export class DefaultServiceCacheState implements AServiceCache {
  Cache = {
    tax: { isPartialLoading: true, cache: {} },
    currency: { isPartialLoading: true, cache: {} },
    consulting_contractor: { isPartialLoading: true, cache: {} },
    inspection_contractor: { isPartialLoading: true, cache: {} },
    customs_contractor: { isPartialLoading: true, cache: {} },
    certification_contractor: { isPartialLoading: true, cache: {} },
    insurance_contractor: { isPartialLoading: true, cache: {} },
  } as { [T in ServiceFieldType]: OptionsCache<any> };
}
